<template>
  <div class="d-flex flex-column flex h100">
    <navbar></navbar>
    <div class="app myContainer">
      <!-- <config-sidenav></config-sidenav> -->
      <div id="content " class="app-content box-shadow-3">
        <!-- Optional navbar at top of page -->
        <div class="navbar navbar-expand-lg">
          <!-- Page title -->
          <!-- Back -->
          <div @click="goBack()" class="backButton">
            <a class="h4">
              <i class="fa fa-angle-left"></i> Back -
            </a>
          </div>
          <div class="navbar-text nav-title flex" id="pageTitle">Assessment Setup</div>
          <!-- Import Assessments -->

					<div v-if="user.client.assessments_upload" class="py-0">
						<button @click="startImport" class="btn btn-sm theme-accent btn-block" v-b-tooltip title="Import Assessments from CSV">
							<i class="far fa-fw fa-file-plus"></i>
							<span class="hidden-folded d-inline">Import Assessments</span>
						</button>
					</div>

          <!-- Create new -->
          <div v-if="user.role.page_create_from_template" class="py-0 ml-2">
            <a
              href="#/myassessments/new"
              class="btn btn-sm theme-accent btn-block"
              v-b-tooltip
              title="Create new assessment from a template"
            >
              <i class="far fa-fw fa-plus"></i>
              <span class="hidden-folded d-inline">New Assessment</span>
            </a>
          </div>

          <!-- Search field -->
          <div>
            <form class="input-group m-2 my-lg-0">
              <span class="input-group-btn">
                <button type="button" class="btn no-border no-bg no-shadow">
                  <i class="fa fa-search"></i>
                </button>
              </span>
              <input
                type="text"
                v-model="filter"
                class="form-control"
                placeholder="Search assessments..."
              />
            </form>
          </div>
        </div>

        <div class="content-main">
          <div class>
            <!-- Page content goes here -->
            <b-table
              ref="table"
              responsive="lg"
              striped
              hover
              :show-empty="true"
              :items="provider"
              :fields="table_fields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
              <!-- Name -->
              <template slot="name" slot-scope="data">
                <div
                  class="constrained-cell"
                  v-tippy="{ interactive: true }"
                  :title="data.item.name"
                >{{ data.item.name }}</div>
              </template>
              <!-- Template -->

              <template slot="template_id" slot-scope="data">
                <div
                  class="constrained-cell"
                  v-tippy="{ interactive: true }"
                  :title="getTemplateName(data.item.template_id)"
                >{{ getTemplateName(data.item.template_id) }}</div>
              </template>
              <template slot="status" slot-scope="data">
                <div v-if="data.item.status" class="constrained-cell">{{data.item.status}}</div>
                <!-- <div v-if="!data.item.feedback" class="constrained-cell" v-tippy="{ interactive: true }" title="Pending Approval">
									{{data.item.status}}
                </div>-->
              </template>

              <!-- Item count -->
              <template slot="items" slot-scope="data">{{ data.item.items.length }}</template>

              <!-- Rubric name
							<template slot="rubric" slot-scope="data">
								<span v-tippy :title="data.item.rubric.name">
									{{data.item.rubric.name}}
								</span>
              </template>-->

              <!-- Actions -->
              <template slot="actions" slot-scope="data">
                <nobr>
                  <div class="mx-auto w90" style="text-align : center">
                    <a
                      v-if="user.role.page_create_from_template"
                      :href="`#/myassessments/${data.item.id}`"
                      class="btn btn-sm btn-icon btn-rounded theme-accent m-0"
                      v-tippy
                      :title="$t('tooltip.edit.item')"
                    >
                      <i class="far fa-edit"></i>
                    </a>
                    <button
                      v-if="data.item.status != 'Submitted'"
                      @click="submitAssesment(data.item)"
                      class="btn btn-sm btn-icon btn-rounded btn-primary m-0"
                      v-tippy
                      title="Submit this Assessment"
                    >
                      <i class="far fa-check"></i>
                    </button>
                    <button
                      v-if="!data.item.inProgress"
                      @click="deleting = data.item"
                      class="btn btn-sm btn-icon btn-rounded red text-white m-0"
                      v-tippy
                      :title="$t('tooltip.delete.item')"
                    >
                      <i class="far fa-trash"></i>
                    </button>
                    <button
                      v-if="data.item.inProgress"
                      class="btn btn-sm btn-icon btn-rounded m-0"
                      v-tippy
                      title="Removing..."
                    >
                      <loading type="icon" />
                    </button>
                  </div>
                </nobr>
              </template>

              <template slot="empty">
                <loading type="table" v-if="loading" />
                <div v-if="!loading">There are no records to show</div>
              </template>
            </b-table>
          </div>
        </div>

        <div class="p-1 b-t mt-auto white d-flex flex-row align-items-center">
          <a class="flex mx-3">
            Page {{ totalRows > 0 ? currentPage : 0 }} of {{ Math.ceil(totalRows / perPage) }} ({{
            totalRows
            }})
          </a>
          <div>
            <b-pagination
              size="md"
              class="m-1"
              :total-rows="totalRows"
              v-model="currentPage"
              :per-page="perPage"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="deleteConfirm" :visible="deleting != false" v-if="deleting">
      <template slot="modal-title">Delete Assessment</template>
      <div class="row px-4 py-2 text-md">
        <h5 class="pt-2 mb-0">
          Are you sure you want to delete the assessment
          <strong
            class="text-theme"
          >"{{ deleting.name }}"</strong>?
        </h5>
        <h5 class="py-2">
          This will have far-reaching effects, including the deletion of the following data:
          <br />
        </h5>
        <ul>
          <li class="text-theme">Administrations of this assessment in existing classes</li>
          <li class="text-theme">Student work submitted using this assessment</li>
          <li class="text-theme">Scores and comments on that work</li>
        </ul>
        <h6 class="py-2">
          <span class="text-danger far faw fa-exclamation-triangle"></span>
          The operation will occur immediately, and cannot be canceled or reversed!
        </h6>
      </div>
      <div class="form-group pl-2 pr-3">
        <input type="text" v-model="deleteConfirm" class="form-control" />
        <small class="text-muted">To confirm, type the name of the assessment</small>
      </div>
      <template slot="modal-footer">
        <button class="btn btn-flat" data-dismiss="modal">Cancel</button>
        <button
          class="btn btn-flat"
          :class="{ [deleting.name != deleteConfirm ? 'btn-secondary' : 'btn-danger']: true }"
          data-dismiss="modal"
          @click="deleteAssessment(deleting)"
          :disabled="deleting.name != deleteConfirm"
        >Delete</button>
      </template>
    </b-modal>

		<b-modal id="importModal" size="lg" v-model="importModal">
			<template slot="modal-title">Import Assessments</template>

			<div class="row p-4">
				<div class="col-12 form-group">
					<h5>Batch Import Assessments</h5>
				</div>
        <div class="col-12 form-group">

        <div class="form-group">
            <label>Pick Template</label>
            <v-select :options="templates" v-model="sTemplate" label="name"></v-select>
          </div>
        </div>
				<div class="col-12">
					<div class="form-group">
						<input id="file-input" class="d-none" type="file" @change="selectImportFile" />
						<button :disabled="sTemplate == null" class="btn hover-darken theme-accent btn-block" @click="click('file-input')">
							Select file...
						</button>
					</div>
					<div class="form-group">
						<input type="text" class="form-control" :value="importingFile && importingFile.name" readonly />
					</div>
          <div v-if="importError" class="form-group text-danger">
              ERROR : {{importError}}
          </div>
          <div v-if="importSuccess" class="form-group text-success">
              INFO : {{importSuccess}}
          </div>
					<div class="form-group" v-if="importStep == 'file select'">
						<p>Things to remember when uploading Assessments:</p>
						<ul style="list-style-type: circle" class="mb-0">
							<li style="list-style-type: circle">Only csv files are supported</li>
							<li style="list-style-type: circle">
								There must be a header row for the csv (id, text) but the names do not matter
							</li>
							<li style="list-style-type: circle">
								Data must be formatted in the following column layout:
							</li>
						</ul>
						<table style="border: 1px solid;" class="my-2 mx-auto">
							<tr>
								<td v-for="header in csvHeaders" v-bind:key="header" class="p-2">{{header}}</td>

							</tr>
						</table>

						<ul style="list-style-type: circle">
							<li style="list-style-type: circle">
								Additional teams beyond the first can be placed in additional columns
							</li>
						</ul>
					</div>


					<div class="col-12 form-group" v-if="importStep != 'file select'">
						<div v-for="(error, i) in importMessages" :key="i">
							<span
								class="_600"
								:class="{
									'text-danger': error.type == 'error',
									'text-warning': error.type == 'warning'
								}"
								>{{ error.message }}</span
							>
							<span class="text-small text-muted">{{ error.result }}</span>
						</div>
					</div>
				</div>
			</div>

			<template slot="modal-footer">
				<button
					class="btn primary btn-flat"
					@click="stopImport"
					v-if="!(importStep == 'failed' || importStep == 'succeeded')"
				>
					Cancel
				</button>
				<button
					class="btn btn-flat"
					v-if="importStep == 'file select' || importStep == 'processed'"
					:disabled="!importingFile"
					:class="{ success: importingFile }"
          @click="Import"
				>
					Import
				</button>
				<button class="btn btn-flat" v-if="importStep == 'processing'" disabled>
					Processing...&nbsp;&nbsp;
					<loading type="icon" />
				</button>
				<button class="btn btn-flat" v-if="importStep == 'importing'" disabled>
					Importing...&nbsp;&nbsp;
					<loading type="icon" />
				</button>
				<button class="btn primary btn-flat" @click="stopImport" v-if="importStep == 'failed'">OK</button>
				<button class="btn primary btn-flat" @click="stopImport" v-if="importStep == 'succeeded'">Done</button>
			</template>
		</b-modal>

    <mzfooter></mzfooter>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w40 {
  width: 40px;
}
.w90 {
  width: 90px;
}
.constrained-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.myContainer {
  padding-right: 60px;
  padding-left: 60px;
}
.backButton {
  padding-right: 20px;
}
</style>

<script>
//UI Components

//Libraries

//Services
import AuthService from "@/services/AuthService";
import AssessmentService from "@/services/AssessmentService";
import TemplateService from "@/services/TemplateService";
import FileService from "@/services/FileService";
import fs from "@/services/FormatService";
import RubricService from "@/services/RubricService";

import store from "@/services/Store";
import Notie from "@/services/NotieService";

export default {
  name: "MyAssessments",

  props: ["user"],

  data() {
    return {
      table_fields: [
        {
          key: "name",
          label: this.$i18n.t("label.name"),
          sortable: true
        },
        {
          key: "ref_id",
          label: this.$i18n.t("label.ref_id"),
          sortable: true
        },

        {
          key: "template_id",
          label: "template",
          // thStyle: { "text-align": "center" },
          tdClass: "p-custom p-0 v-mid switch-fix",
          sortable: true
        },
        {
          key: "status",
          label: "Status",
          sortable: true
        },
        {
          key: "actions",
          label: this.$i18n.t("label.actions"),
          thStyle: { "text-align": "center" },
          tdClass: "p-custom p-0 v-mid"
        }
      ],
      fs: fs,
      currentPage: 1,
      perPage: 15,
      templates: [],
      totalRows: 0,
      filter: "",
      sortBy: null,
      sortDesc: false,
      loading: true,
      processedAssessments: [],
      sTemplate:null,
      importModal: false,
			importingFile: null,
			importStep: "file select",
			importDone: 0,
			importTotal: 1,
			importErrors: [],
      csvHeaders :[],
      importSuccess:null,
      importError :null,
      deleting: false,
      deleteConfirm: ""
    };
  },

  created() {
    this.sortBy = store.get(this, "items.sortBy");
    this.sortDesc = store.getDefault(this, "items.sortDesc", false);
  },

  watch: {
    sTemplate(newVal){
      this.createCSVHeaders(newVal)
      console.log("Template was selected . ")
    },
    sortBy() {
      store.set(this, "items.sortBy", this.sortBy);
    },
    sortDesc() {
      store.set(this, "items.sortDesc", this.sortDesc);
    }
  },

  methods: {
    provider(ctx) {
      ctx.my_assessments = true;
      return AssessmentService.listTempAssessments(ctx)
        .then(resp => {
          console.log("amt ,",resp.data.assessments)
          this.totalRows = resp.data.totalRows;
          this.LoadTemplates();
          return resp.data.assessments;
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to load assessments", err);
          return [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

		startImport() {
			this.importModal = true;
			this.importingFile = null;
			this.importingRequests = null;
			this.importMessages = [];
			this.importStep = "file select";
			this.emailBehavior = this.emailBehaviors[0];
    },
    
    Import(){
        for (const assessment of this.processedAssessments) {
          this.saveAssessment(assessment,assessment.rubric)  
        }
        this.importStep = 'succeeded'
        this.importSuccess = "Assessmnets were imported successfully."

    },

		stopImport() {
			this.importModal = false;
			this.importingFile = null;
			this.importingRequests = null;
			this.importMessages = [];
			this.importStep = "file select";
		},


    LoadTemplates() {
      return TemplateService.listTemplates()
        .then(resp => {
          console.log("Got templates", resp.data);
          this.templates = resp.data.templates;
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to Get Templates", err);
        });
    },

    createCSVHeaders(template){
      let headers = ["name","description"]
      for (let index = 0; index < template.test.length; index++) {
        headers.push("content_"+index)
  
      }
      this.csvHeaders = headers
    },
    setActive(item) {
      if (item.active) {
        AssessmentService.activateAssessment(item.id)
          .then(resp => {
            Notie.success("Assessment marked as active");
            this.refreshTable();
          })
          .catch(err => {
            console.log(err);
            Notie.error("Failed to activate assessment", err);
            item.active = false;
          });
      } else {
        AssessmentService.deactivateAssessment(item.id)
          .then(resp => {
            Notie.success("Assessment marked as inactive");
            this.refreshTable();
          })
          .catch(err => {
            console.log(err);
            Notie.error("Failed to deactivate assessment", err);
            item.active = true;
          });
      }
    },
		validateImportUsers(file) {
      console.log(file.type);
			if (file.type != "text/csv" && file.type != "application/vnd.ms-excel") {
				this.importingFile = null;
				notie.error("File must be CSV!");
				return;
      }
      
      this.importStep = "processing";
      var reader = new FileReader();
      reader.onload = e => {
				console.log("File loaded");
        var usersCSV = FileService.CSVToArray(e.target.result);

        if(usersCSV[0].length != this.csvHeaders.length){
          this.importStep = 'file select'
          this.importError = "Different headers size detected"
            console.error("Different headers size detected");
            return
        } 
        else { 
          for (const header of usersCSV[0]) {

            if(this.csvHeaders.includes(header) == false){
              this.importError = header + " is in the headers but not required."
              console.error(this.importError)
              return
            }
          }

          for (const header of this.csvHeaders) {
            if(usersCSV[0].includes(header) == false){
              this.importError = header + " is not defined in the CSV File but it's required."
              console.error(this.importError)
              return
            }
          }

        }
        this.importError = null
        console.log(" Start processing ")
        let assessments_array = this.processAssessments(usersCSV)
        console.log(" Assessments processed " ,assessments_array);
        this.importStep = "importing"
        let assessments = []

      for (let i = 0; i < assessments_array.length; i++) {
        let array = assessments_array[i]
        let assessment = {}

        assessment.name = array.name
        assessment.ref_id = this.generateAutoRef(assessment.name);
        assessment.description = array.description

        assessment.essential_skills = []
        assessment.assessment_purpose = []
        assessment.standards = []
        assessment.secondary_content_area_id = []
        assessment.content_area_id = this.sTemplate.content_area_id

        assessment.template_id = this.sTemplate.id
        assessment.test = this.sTemplate.test
        assessment.student_notes = this.sTemplate.student_notes
        assessment.type = this.sTemplate.type
        assessment.loaded = 1
        assessment.rubric = this.sTemplate.rubric

        assessment.test_responses = []

        for (let index = 0; index < this.sTemplate.test.length; index++) {
          let key = "content_" + index
          assessment.test_responses.push(array[key])
        }
        // this.saveAssessment(assessment,assessment.rubric)
        assessments.push(assessment)

      }
      this.processedAssessments = assessments
      console.log(assessments)
      this.importStep = "processed"
        // here create blank assessment like template assessment and template rubric and then save it.

        
    }

    reader.readAsText(file)
    },
    
    processAssessments(usersCSV){
      let assessments  = []
      for (let index = 1; index < usersCSV.length; index++) {
        let assessment_object = {}
        for (let j = 0; j < usersCSV[index].length; j++) {
          assessment_object[this.csvHeaders[j]] =  usersCSV[index][j]
        }
        assessments.push(assessment_object)
      }
      return assessments

    },

   saveAssessment(assessment,rubric) {
      // debugger;
      console.log(rubric)
      // this.template.rubric.traits = this.getNewTraits()
      return RubricService.saveTempRubric(rubric)
        .then(resp => {
          console.log("Rubric Saved", resp.data.id);
          //saving assessment after saving rubric

          assessment.item = {}
          assessment.item.rubric = assessment.rubric;
          assessment.item.type = assessment.type;
          assessment.item.standards = assessment.standards;
          assessment.item.essential_skills = assessment.essential_skills;
          assessment.item.assessment_purpose = assessment.assessment_purpose;

          assessment.rubric_id = resp.data.id;
          assessment.item.rubric_id = resp.data.id;
          assessment.user_id = this.user.id;
          assessment.status = "In Progress";

          return AssessmentService.saveTempAssessment(assessment)
            .then(resp => {
                console.log(" Saved : ",assessment)
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
		selectImportFile(event) {
			console.log("===CHOOSE FILE===");
			console.log(event.target.files);
			if (event.target.files[0]) {
				this.importingFile = event.target.files[0];
				this.validateImportUsers(this.importingFile);
			}
		},

    click(id) {
			var el = document.getElementById(id);
			if (el) {
				el.value = "";
				el.click();
			}
		},
    submitAssesment(item) {
      AssessmentService.activateTempAssessment(item.id)
        .then(resp => {
          Notie.success("Assessment was submitted");
          this.refreshTable();
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to activate assessment", err);
          item.active = false;
        });
    },
    generateAutoRef(name) {
      return name && fs.toGoodRefID(name);
    },
    getTemplateName(id) {
      try {
        return this.templates.find(element => element.id == id)["name"];

      } catch(e) {
        return "Undefined Name"
      }
    },
    deleteAssessment(asmt) {
      asmt.inProgress = true;
      AssessmentService.removeTempAssessment(asmt.id)
        .then(resp => {
          Notie.info("Assessment deleted");
          this.refreshTable();
        })
        .catch(err => {
          Notie.error("Failed to delete assessment", err);
        })
        .finally(() => {
          item.inProgress = false;
          this.$forceUpdate();
        });
      this.deleting = false;
    },
    goBack() {
      this.$router.go(-1);
    },
    refreshTable() {
      this.$refs.table.refresh();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/MyAssessments.vue